/**
 * SSO des hôtes standalone (bi.meteris.fr, rc.meteris.fr).
 *
 * Ces deux noms servent le MÊME frontend que le portail, mais sous un autre hôte.
 * Or Microsoft renvoie toujours sur support.meteris.fr (`redirect_uri` figé côté
 * Entra), et depuis la décision du 07/09/2026 les cookies sont liés à l'hôte.
 * Un flux démarré depuis bi pose donc son cookie d'état anti-CSRF sur bi, où le
 * callback — qui s'exécute sur support — ne le trouvera jamais.
 *
 * On démarre donc le flux SUR le portail, en lui annonçant l'origine : elle
 * repartira chercher sa session avec un jeton de handoff (cf routers/auth.py).
 */

export const PORTAL_ORIGIN =
  process.env.REACT_APP_PORTAL_URL || 'https://support.meteris.fr';

// Liste EXACTE, alignée sur CROSS_DOMAIN_SSO_HOSTS côté backend : ce qui figure
// ici obtient une session par handoff.
export const STANDALONE_HOSTS = ['bi.meteris.fr', 'rc.meteris.fr'];

export function isStandaloneHost(hostname) {
  return STANDALONE_HOSTS.includes(String(hostname || '').toLowerCase());
}

/**
 * URL de démarrage du SSO. Relative depuis le portail (rien à traverser),
 * absolue vers le portail depuis un hôte standalone.
 */
export function ssoStartUrl(path, { hostname, espace } = {}) {
  const query = `?espace=${encodeURIComponent(espace || 'tech')}`;
  if (!isStandaloneHost(hostname)) return `${path}${query}`;
  return `${PORTAL_ORIGIN}${path}${query}&origin_host=${encodeURIComponent(hostname)}`;
}
